"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getTravelerLabel: ()=>getTravelerLabel
});
function pluralize(singularName, pluralName, count, concat) {
    if (!count || count <= 0) return '';
    return `${concat ? ', ' : ''}${count} ${1 === count ? singularName : pluralName}`;
}
function getTravelerLabel({ adults = 0, children = 0, lapInfants = 0, rooms = 0 }) {
    const adultLabel = pluralize('Adult', 'Adults', adults, false);
    const childLabel = pluralize('Child', 'Children', children, true);
    const infantLabel = pluralize('Infant', 'Infants', lapInfants, true);
    const roomLabel = pluralize('Room', 'Rooms', rooms, true);
    let label = adultLabel;
    label += childLabel;
    label += infantLabel;
    label += roomLabel;
    const twoTypesOfChildren = children > 0 && lapInfants > 0;
    const travelerCount = (adults ?? 0) + (children ?? 0);
    const travelerLabel = `${travelerCount} Travelers` + infantLabel + roomLabel;
    return twoTypesOfChildren ? travelerLabel : label;
}
exports.getTravelerLabel = __webpack_exports__.getTravelerLabel;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getTravelerLabel"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
